import * as React from "react";
import { Route } from 'react-router-dom';
import { FormulairePage } from '../formulaire/formulaire';
import ChangePassword from "../pages/change-password";
export default [
    <Route exact path="/formulaire" component={FormulairePage} />,
    <Route exact path="/change-password" component={ChangePassword} />,
];
